import { useEffect, useState } from "react";
import { Plus, Trash2, Save, Image as ImageIcon } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { PageHeader, Btn, Field } from "@/components/admin/ui";
import MediaPicker from "@/components/admin/MediaPicker";

export default function Press() {
  const [items, setItems] = useState([]);
  const [picker, setPicker] = useState(null);
  const load = () => api.get("/admin/media-coverage").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const add = async () => { await api.post("/admin/media-coverage", { outlet: "Outlet", title: "", url: "", order: items.length }); toast.success("Added"); load(); };
  const save = async (m) => { await api.put(`/admin/media-coverage/${m.id}`, m); toast.success("Saved"); load(); };
  const del = async (id) => { if (!window.confirm("Delete?")) return; await api.delete(`/admin/media-coverage/${id}`); toast.success("Deleted"); load(); };
  const upd = (id, patch) => setItems(items.map((m) => m.id === id ? { ...m, ...patch } : m));

  return (
    <div data-testid="admin-press">
      <PageHeader title="Media Coverage" subtitle="Press articles and featured coverage">
        <Btn onClick={add}><Plus size={16} /> Add Coverage</Btn>
      </PageHeader>
      <div className="space-y-4">
        {items.map((m) => (
          <div key={m.id} className="bg-white rounded-2xl border border-stone-200/80 p-6 space-y-3">
            <div className="grid md:grid-cols-2 gap-3">
              <Field label="Outlet" value={m.outlet} onChange={(v) => upd(m.id, { outlet: v })} />
              <Field label="Title" value={m.title} onChange={(v) => upd(m.id, { title: v })} />
              <Field label="Article URL" value={m.url} onChange={(v) => upd(m.id, { url: v })} />
              <div><span className="text-sm font-medium text-emerald-900">Image</span>
                <div className="flex gap-2 mt-1"><input value={m.image || ""} onChange={(e) => upd(m.id, { image: e.target.value })} className="flex-1 rounded-lg border border-stone-300 px-3 py-2 text-sm outline-none" /><button onClick={() => setPicker(() => (url) => upd(m.id, { image: url }))} className="rounded-lg border border-stone-300 px-3 py-2 hover:bg-stone-100"><ImageIcon size={15} /></button></div>
              </div>
            </div>
            <div className="flex justify-end gap-2"><button onClick={() => del(m.id)} className="p-2 rounded-lg hover:bg-red-50 text-red-500"><Trash2 size={16} /></button><Btn onClick={() => save(m)}><Save size={16} /> Save</Btn></div>
          </div>
        ))}
      </div>
      <MediaPicker open={!!picker} onClose={() => setPicker(null)} onSelect={(url) => picker && picker(url)} />
    </div>
  );
}
